/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

export const API_TAGS = {
  ACTIVITIES: 'Activities',
  ANALYTICS: 'Analytics',
  API_TOKENS: 'ApiTokens',
  AUDIT_LOGS: 'AuditLogs',
  AUTH: 'Auth',
  AUTOMATED_ANSWERS: 'AutomatedAnswers',
  BACKUPS: 'Backups',
  BOTS: 'Bots',
  BOT_DEPLOYMENTS: 'BotDeployments',
  BOT_TEMPLATES: 'BotTemplates',
  BROADCASTS: 'Broadcasts',
  CHAPTER_SOURCES: 'ChapterSources',
  CHAT_SESSIONS: 'ChatSessions',
  DASHBOARD: 'Dashboard',
  DEFAULT_FALLBACK: 'DefaultFallback',
  GROUPS: 'Groups',
  INTEGRATIONS: 'Integrations',
  JOBS: 'Jobs',
  KNOWLEDGE_BASES: 'KnowledgeBases',
  KNOWLEDGE_BASE_ARTICLES: 'KnowledgeBaseArticles',
  KNOWLEDGE_BASES_ARTICLES: 'KnowledgeBasesArticles',
  KNOWLEDGE_BASE_ARTICLES_TAGS: 'KnowledgeBasesArticlesTags',
  KNOWLEDGE_BASE_GROUPS: 'KnowledgeBasesGroups',
  LIVE_CHAT: 'LiveChat',
  LIVE_CHAT_CONVERSATIONS: 'LiveChatConversations',
  LIVE_CHAT_CONVERSATION_NOTES: 'LiveChatConversationNotes',
  LIVE_CHAT_CONVERSATION_TAGS: 'LiveChatConversationTags',
  LIVE_CHAT_MESSAGES: 'LiveChatMessages',
  LIVE_CHAT_REQUESTS: 'LiveChatRequests',
  LIVE_CHAT_SETTINGS: 'LiveChatSettings',
  LIVE_CHAT_SYSTEM_MESSAGES: 'LiveChatSystemMessages',
  MEDIA_FILES: 'MediaFiles',
  MISSED_QUESTIONS: 'MissedQuestions',
  MONITORING: 'Monitoring',
  NLP_PIPELINES: 'NlpPipelines',
  HELVIA_PIPELINE_SETTINGS: 'HelviaPipelineSettings',
  NLP_FLOWS: 'NlpFlows',
  ORGANIZATION: 'Organization',
  ORGANIZATION_PUBLIC: 'OrganizationPublic',
  ORGANIZATION_SUBSCRIBERS: 'OrganizationSubscribers',
  PREDEFINED_ENTITIES: 'PredefinedEntities',
  SCHEDULED_REPORTS: 'ScheduledReports',
  STORY: 'Story',
  SURVEYS: 'Surveys',
  TAGS: 'tags',
  TEST_SETS: 'TestSets',
  USERS: 'Users',
  USER_GROUPS: 'UserGroups',
  TICKETS: 'Tickets',
  TOPIC_MODELLING_JOBS: 'TopicModellingJobs',
  MESSENGER_PROFILE: 'MessengerProfile',
  NOTIFICATIONS: 'Notifications',
  CSAT: 'CSAT',
  STATIC_VARIABLES: 'StaticVariables',
  AUTOMATED_TESTS: 'AutomatedTests',
  INTERACTIONS_METADATA: 'InteractionsMetadata'
};
